import { SearchOutlined } from '@ant-design/icons';
import { Flex, Input, theme } from 'antd';
import dayjs, { type Dayjs } from 'dayjs';
import { type ReactNode, useEffect, useState } from 'react';
import DateRangePicker from '../../../components/controls/date-range-picker';
import { LocalDate } from '../../../utils/local-date';

export interface CycleMenusFiltersProps {
  onChange?: (filters: FiltersState) => void;
  initialFilters?: FiltersState;
}

interface FiltersState {
  query?: string;
  startDate?: [LocalDate, LocalDate];
  endDate?: [LocalDate, LocalDate];
}

const CycleMenusFilter = (props: CycleMenusFiltersProps): ReactNode => {
  const { initialFilters, onChange } = props;
  const [filters, setFilter] = useState<FiltersState>(initialFilters ?? {});
  const { token } = theme.useToken();

  useEffect(() => {
    onChange?.(filters);
  }, [filters]);

  return (
    <Flex gap={token.paddingXS} flex={1}>
      <Input
        allowClear
        value={filters?.query}
        placeholder="Search"
        prefix={<SearchOutlined />}
        onChange={(e) => {
          setFilter((prev) => ({
            ...prev,
            query: e.target?.value || undefined,
          }));
        }}
        style={{ maxWidth: 300, marginInlineEnd: token.marginMD }}
      />

      <DateRangePicker
        value={filters.startDate?.map((date) => dayjs(date.toString())) as [Dayjs, Dayjs]}
        title="Start date"
        showOnlyDateRange={true}
        onChange={(value) => {
          setFilter((prev) => ({
            ...prev,
            startDate: value?.map((v) => new LocalDate(v)) as [LocalDate, LocalDate] | undefined,
          }));
        }}
      />

      <DateRangePicker
        value={filters.endDate?.map((date) => dayjs(date.toString())) as [Dayjs, Dayjs]}
        title="End date"
        showOnlyDateRange={true}
        onChange={(value) => {
          setFilter((prev) => ({
            ...prev,
            endDate: value?.map((v) => new LocalDate(v)) as [LocalDate, LocalDate] | undefined,
          }));
        }}
      />
    </Flex>
  );
};

CycleMenusFilter.defaultProps = {
  onChange: (_filters: FiltersState) => {},
  initialFilters: {},
};

export default CycleMenusFilter;
